export default __webpack_public_path__ + "static/media/regulatory--keep-right--g9.19cca104.png";